import React from 'react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-navy-dark px-5 py-14" data-id="element-98" data-mp="3geze367ujv27">
      <div className="mx-auto max-w-5xl text-center" data-id="element-99" data-mp="3gh3n22klrk9c">
        <p className="font-display text-xl font-black uppercase tracking-tight text-white" data-id="element-100" data-mp="32p5m4f11ouo9">
          <span aria-hidden="true" data-id="element-101" data-mp="36qhdoq3hbpz3">📐 </span>Mathématiques Prêtes™
        </p>
        <p className="mx-auto mt-3 max-w-md text-xs leading-relaxed text-white/55" data-id="element-102" data-mp="3ueim7z0nr6ei">
          La ressource définitive pour les professeurs de mathématiques qui
          aiment leur métier.
        </p>
        <nav aria-label="Pied de page" data-id="element-103" data-mp="3levkfc40nykx">
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-white/65" data-id="element-104" data-mp="3le2icog05x94">
            {footerLinks.map(link => <li key={link} data-id="element-105" data-mp="29y5hc1uw3mvj">
                <a href="#offre" className="transition-colors hover:text-tangerine" data-id="element-106" data-mp="29xvrce9uhfpu">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-white/40" data-id="element-107" data-mp="3gapfjptkcwj5">
          © 2026 Mathématiques Prêtes™ — Tous droits réservés.
        </p>
      </div>
    </footer>;
}